import React, {useContext, useEffect, useState} from 'react';
import GenerateURL from "../../utils/generateURL";
import {INDEX_ROUTE} from "../../utils/consts";
import {NavLink} from "react-router-dom";
import Search from "../Search";
import Language from "../Language";

import logo from '../../img/logo.svg'
import Menu from "../Menu";
import {useWindowSize} from "../../hooks/useWindowSize";
import {observer} from "mobx-react-lite";
import {MobileMenuContext} from "../../App";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";

const Header = () => {
    const size = useWindowSize();
    const [top, setTop] = useState('0px');
    const [logoOpacity, setLogoOpacity] = useState(true);
    const [mobileMenu, setMobileMenu] = useContext(MobileMenuContext);

    useEffect(() => {
        const headerHidden = () => {
            document.querySelector('.footer')
                ? setTop((window.innerHeight * 2 < document.body.offsetHeight) && (window.scrollY + window.innerHeight > document.body.offsetHeight - document.querySelector('.footer').offsetHeight) ? '-100px' : '0px')
                : setTop('0px');
            const top = getComputedStyle(document.querySelector('header.header'));
            if (parseInt(top.top) === -100 && document.querySelector('html').classList.contains('fixed')) {
                setTop('-100px')
            }
        };
        document.addEventListener('scroll', headerHidden);

        return () => {
            document.removeEventListener('scroll', headerHidden);
        }
    }, [size]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const checkIfClickedOutside = e => {
            setTimeout(() => {
                if (!e.target.closest('.mobile_menu') && !e.target.closest('.mobile_click')) {
                    ScrollToPositionFixed(true);
                    setMobileMenu(false);
                }
            }, 400)
        };
        if (mobileMenu) {
            document.addEventListener("click", checkIfClickedOutside);
        }
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [mobileMenu]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <header
            className={`header ${mobileMenu ? 'open' : ''}`}
            style={{top: top}}
        >
            <div className="row">
                <div className="left_block">
                    <NavLink
                        className={`logo ${document.body.clientWidth <= 567 ? logoOpacity ? '' : 'opacity' : ''}`}
                        to={GenerateURL(INDEX_ROUTE)}
                    ><img src={logo} alt="logo"/>
                    </NavLink>
                </div>
                {document.body.clientWidth > 1280 && <Menu/>}
                <div className="right_block">
                    <div className="right_block_content">
                        {!mobileMenu && <Search logoOpacity={logoOpacity} setLogoOpacity={setLogoOpacity}/>}
                        {document.body.clientWidth > 1280 && <Language/>}
                        {document.body.clientWidth <= 1280 && <>
                            <button
                                type="button"
                                className={`mobile_click ${mobileMenu ? 'open' : ''}`}
                                onClick={() => {
                                    if (mobileMenu) {
                                        ScrollToPositionFixed(true);
                                        setMobileMenu(false);
                                    } else {
                                        setMobileMenu(!mobileMenu);
                                        ScrollToPositionFixed(false, window.pageYOffset);
                                    }
                                }}
                            ><span/><span/><span/>
                            </button>
                            <div className={`mobile_menu ${mobileMenu ? 'open' : ''}`}>
                                <div className="logo">
                                    <NavLink to={GenerateURL(INDEX_ROUTE)}>
                                        <img src={logo} alt="ChampionStudio"/>
                                    </NavLink>
                                </div>
                                <div className="content" style={{display: mobileMenu ? 'block' : 'none'}}>
                                    <Search/>
                                    <Menu setMobileMenu={setMobileMenu}/>
                                    <Language setMobileMenu={setMobileMenu}/>
                                    <div className="bottom">
                                        <span>{new Date().getFullYear()} © ChampionStudio.net</span>
                                    </div>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default observer(Header);